import { IPagination } from "src/app/model/IPagination";

export class StoredPaginationStoreAction {
    static readonly type = "[StoredPagination] Store item";
    constructor(public payload: Partial<IPagination>) {}
}

export class StoredPaginationResetAction {
    static readonly type = "[StoredPagination] Reset item";
    constructor(public payload: string) {}
}
